<template>
  <div class="index-container" v-loading="loading">
    <div class="left-panel">
      <div class="section-1">
        <div class="item" v-for="(item, index) in currentTabs" :key="index">
          <div class="title" v-if="index == 0">{{ item.label }}</div>
          <div
            v-else
            class="item-child"
            :class="{ active: index == tabIndex }"
            @click="changeTabs(item.id, index)"
          >
            <a href="javascript:;">{{ item.label }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="right-panel">
      <div class="right-content-title">
        <div class="bage"></div>
        <div class="title">{{ mainTab }}</div>
      </div>
      <div class="line"></div>

      <div class="tabs" v-if="showChildTabs">
        <div
          class="tab-item"
          :class="{ active: index == currentChildTab }"
          v-for="(tab, index) in childrenTabs"
          :key="index"
          @click="changeChildTab(tab.id, index)"
        >
          {{ tab.label }}
        </div>
      </div>

      <div>
        <Video v-if="!showDetail" :videos="news" @detail="detail"></Video>
        <ArticleDetail v-else :article="article"></ArticleDetail>
      </div>
      <div
        style="width: 100%; text-align: center"
        v-if="!showDetail"
      >
        <el-pagination
          v-show="total>0"
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="total"
          @prev-click="prev"
          @next-click="next"
          @current-change="current"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Video from "./Video";
import ArticleDetail from "./ArticleDetail.vue";
import { getNewsDetail } from "../api/article";
export default {
  components: {
    ArticleDetail,
    Video,
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      tabIndex: 1,
      currentChildTab: 0,
      mainTab: "",
      showDetail: false,
      article: {},
      id: "",
    };
  },
  async created() {
    this.$store.dispatch('getColumns').then(() =>{
      let path = this.$route.matched[0].path;
      this.$store.commit("SET_CURRENTTYPE", { path: path });
    });
    let objStr = localStorage.getItem("SET_HOMENEWS");
    let obj = JSON.parse(objStr);
    if (objStr != null) {
      this.tabIndex = obj.tabIndex;
      await this.detail(obj.newsId);
      localStorage.removeItem("SET_HOMENEWS");
    } 
  },
  computed: {
    ...mapGetters({
      currentTabs: "currentTabs",
      total: "total",
      news: "news",
      showChildTabs: "showChildTabs",
      childrenTabs: "childrenTabs",
      loading: "loading",
    }),
  },
  watch: {
    async currentTabs(val) {
      if (val != null && val.length != 0) {
        if (val.length > 2) {
          let objStr = localStorage.getItem("SET_HOMENEWS");
          let obj = JSON.parse(objStr);
          if (objStr != null) {
            let tab = val.filter((p) => p.id == obj.columnId);
            let index = val.indexOf(tab[0]);
            this.mainTab = tab[0].label;
            this.tabIndex = index;
          } else {
            this.mainTab = val[this.tabIndex].label;
            this.id = val[1].id;
            this.$store.commit("SET_CHILDTABS", { id: this.id });
            if (!this.showChildTabs) {
              await this.getNews({
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                columnId: val[1].id,
                order: "descending,ascending,descending",
                field: "top,sortOrder,createTime",
              });
            }
          }
        } else {
          this.mainTab = val[0].label;
        }
      }
    },
    async childrenTabs(val) {
      if (val != null && val.length != 0) {
        await this.getNews({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          columnId: val[0].id,
          order: "descending,ascending,descending",
          field: "top,sortOrder,createTime",
        });
      }
    },
  },
  methods: {
    ...mapActions({
      getNews: "getNews",
    }),
    async changeChildTab(id, index) {
      this.currentChildTab = index;
      await this.getNews({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        columnId: id,
        order: "descending,ascending,descending",
        field: "top,sortOrder,createTime",
      });
      localStorage.removeItem("SET_HOMENEWS");
    },
    async changeTabs(id, index) {
      this.currentChildTab = 0;
      await this.getNews({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        columnId: id,
        order: "descending,ascending,descending",
        field: "top,sortOrder,createTime",
      });
      this.id = id;
      this.tabIndex = index;
      this.mainTab = this.currentTabs[index].label;
      this.showDetail = false;
      this.$store.commit("SET_CHILDTABS", { id: this.id });
      localStorage.removeItem("SET_HOMENEWS");
    },
    async detail(id) {
      this.showDetail = true;
      this.$store.commit("SET_SHOWCHILDTABS");
      let result = await getNewsDetail(id);
      this.article = result.data;
    },
    async prev(val) {
      await this.getNews({
        pageNum: val,
        pageSize: this.pageSize,
        columnId: this.id,
        order: "descending,ascending,descending",
        field: "top,sortOrder,createTime",
      });
      localStorage.removeItem("SET_HOMENEWS");
    },
    async next(val) {
      await this.getNews({
        pageNum: val,
        pageSize: this.pageSize,
        columnId: this.id,
        order: "descending,ascending,descending",
        field: "top,sortOrder,createTime",
      });
      localStorage.removeItem("SET_HOMENEWS");
    },
    async current(val) {
      await this.getNews({
        pageNum: val,
        pageSize: this.pageSize,
        columnId: this.id,
        order: "descending,ascending,descending",
        field: "top,sortOrder,createTime",
      });
      localStorage.removeItem("SET_HOMENEWS");
    },
  },
};
</script>

<style lang="less" scoped>
.index-container {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  .line {
    width: 100%;
    height: 1px;
    background-color: #dddddd;
    margin-top: 15px;
  }
  
  .right-panel {
    width: 1064px;
    margin-left: 40px;
    .tabs {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .tab-item {
        width: 152px;
        height: 40px;
        border-radius: 5px;
        background: #dddddd;
        text-align: center;
        line-height: 40px;
        vertical-align: middle;
        margin-left: 16px;
        margin-top: 24px;
      }
      .active {
        background: #b7171d;
        color: #ffffff !important;
      }

      a {
        width: 100%;
        height: 100%;
        color: #333333;
      }
    }
    .right-content-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .bage {
        width: 4px;
        height: 24px;
        background-color: #b7171d;
        margin-right: 11px;
      }
      .title {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        vertical-align: middle;
      }
    }
  }
  .left-panel {
    width: 344px;
    min-height: 545px;
    .section-1 {
      width: 100%;
      .item {
        text-align: center;
        vertical-align: middle;
        line-height: 59px;
        .title {
          background-color: #b7181e;
          color: #fff;
          font-size: 24px;
          border: 1px solid #b7181e;
          font-weight: 600;
        }
        .item-child {
          border: 1px solid rgba(208, 208, 208, 0.59);
          font-size: 20px;
          border-top: 0;
          a {
            color: black;
          }
        }
        .active {
          color: #b7181e !important;
          font-weight: 600;
          a {
            color: #b7181e;
          }
        }
      }
    }
    .section-2 {
      width: 100%;
      margin-top: 24px;
      height: 96px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .section-3 {
      .image {
        width: 100%;
        height: 120px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        width: 100%;
        .news-item {
          width: 100%;
          margin-top: 5px;
          white-space: nowrap;
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          a {
            color: #a6a6a6;
          }
        }
      }
    }

    .section-4 {
      a {
        color: #a6a6a6;
      }
      .sub-1 {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .sub-image {
          width: 48%;
          height: 150px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .sub-content {
          width: 48%;
          .sub-title {
            font-size: 18px;
            color: black;
          }
          .sub-detail {
            color: #555555;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 15px;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
          }
        }
      }
      .content {
        .news-item {
          width: 100%;
          white-space: nowrap;
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-top: 5px;
          a {
            color: #a6a6a6 !important;
          }
        }
      }
    }
    .section-5 {
      a {
        color: #fff;
      }
      .sub-1 {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .sub-image {
          width: 48%;
          height: 150px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .sub-content {
          width: 48%;
          .sub-title {
            font-size: 18px;
            color: black;
          }
          .sub-detail {
            p {
              color: #555555;
              // text-overflow: ellipsis;
              // overflow: hidden;
              line-height: 15px;
              // display: -webkit-box;
              // -webkit-line-clamp: 7;
              // -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
}
</style>